import RecentlyViewed from './RecentlyViewed'

export default RecentlyViewed
